import { render } from "./BlogDetails.vue?vue&type=template&id=53808614"
import script from "./BlogDetails.vue?vue&type=script&lang=js"
export * from "./BlogDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__